module.exports = __webpack_public_path__ + "img/renwu.c774c27e.png";